'use client';

import { PropsWithClassname } from '@/app/types';
import { useTranslation } from 'react-i18next';

import Image from 'next/image';

import Dialog from '@/app/components/Dialog/Dialog';
import { Country } from '@/app/enums';
import { getCountryConfig } from '@/app/utils/countryConfig';

interface CertificatePreviewDialogProps extends PropsWithClassname {
  isOpen: boolean;
  onClose: () => void;
}

const countryConfig = getCountryConfig();

const CertificatePreviewDialog = ({ isOpen, onClose, className }: CertificatePreviewDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      isCloseButtonVisible
      closeButtonText={t('components.CertificatePreviewDialog.close')}
    >
      <Image
        width={864}
        height={612}
        src={
          countryConfig.country === Country.CZECH_REPUBLIC
            ? '/public/images/certificate-preview.svg'
            : '/public/images/certificate-preview-sk.png'
        }
        alt={t('components.CertificatePreviewDialog.imageCaption')}
        className="w-full h-auto rounded-md mt-[16px] mb-[16px]"
      />
      <p className="text-center text-neutral-semiTransparent">
        {t('components.CertificatePreviewDialog.imageCaption')}
      </p>
    </Dialog>
  );
};

export default CertificatePreviewDialog;
